import { Grow, NoSsr, Skeleton, SxProps } from "@mui/material";
import { ChevronLeft } from "lucide-react";
import { useSwiper } from "swiper/react";
import SwiperNavigationButton from "./SwiperNavigationButton";

const SwiperNextButton = ({ sx }: { sx?: SxProps }) => {
    const swiperRef = useSwiper();
    const styles: SxProps = {
        top: 'unset',
        left: { xs: 'unset', sm: 'unset' },
        bottom: 16,
        right: 16,
        ...sx
    }

    return <NoSsr fallback={<Skeleton variant="circular" height={42} width={42} sx={{
        position: 'absolute',
        bgcolor: '#ffffff80',
        zIndex: 2,
        ...styles,
    }} />}>
        <Grow in={true}>
            <SwiperNavigationButton sx={styles}
                color="default"
                aria-label="اسلاید بعدی"
                onClick={() => {
                    swiperRef.slideNext()
                }}>
                <ChevronLeft size={23} />
            </SwiperNavigationButton>
        </Grow>
    </NoSsr>
}

export default SwiperNextButton;